import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';

import { TercerosVigentesCapitalFechaCorteComponent } from './TercerosVigentesCapitalFechaCorte.component';


import { RoleGuardService as RoleGuard } from '../Seguridad/role-guard.service';





const routes = [
    {
        path     : 'TercerosVigentesCapitalFechaCorte',
        component: TercerosVigentesCapitalFechaCorteComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'TercerosVigentesCapitalFechaCorte',
          nombreFormulario : 'SaldoIndemTercerosVigentesCapitalFechaCortenizaciones'
        } 
    }
];

@NgModule({
    declarations: [
        TercerosVigentesCapitalFechaCorteComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        TercerosVigentesCapitalFechaCorteComponent
    ]
})

export class TercerosVigentesCapitalFechaCorteModule
{
}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/TercerosVigentesCapitalFechaCorte/TercerosVigentesCapitalFechaCorte.module.ts